(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Auth', Auth);

    Auth.$inject = ['User', '$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider',
        'Account', 'CoreService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish',
        'ROLES', '$http', 'AuthItem'];

    function Auth(User, $rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider,
                  Account, CoreService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish,
                  ROLES, $http, AuthItem) {

        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            loadResourceAccess: loadResourceAccess,
            loadActionAccess: loadActionAccess,
            loadActionsAccess: loadActionsAccess,
            resourceAuthorize: resourceAuthorize,
            actionAuthorize: actionAuthorize,
            checkActionAuthorization: checkActionAuthorization,
            hasActionAuthorization: hasActionAuthorization
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(checkBrowser);

            return authReturn;

            function checkBrowser() {
                var isAuthenticated = Principal.isAuthenticated();

                if(force && !isAuthenticated){
                    stowStateAndSendSignin();
                }

                if (isAuthenticated) {
                    Principal.hasAuthority(ROLES.ROLE_SYSTEM_ADMIN).then(checkRoleAdmin);
                } else {
                    authThen();
                }
            }

            function checkRoleAdmin(response) {
                if (response) {
                    authThen();
                } else {
                    var fromCookie = CoreService.getUUID();

                    User.checkBrowser({browserUuid: fromCookie}).$promise.then(checkBrowserThen);
                }
            }

            function checkBrowserThen(response) {
                var employee = CoreService.getCurrentEmployee();

                if (response.result) {
                    // console.log("line 86");
                    if (employee.signed === true) {
                        // console.log("is signed" );
                        // console.log(employee);
                        authThen();
                    } else {
                        // console.log("go to consent" );
                        $state.go('consent');
                    }
                } else {
                    // console.log("line 95");
                    if ($rootScope.toState.name !== 'security-code') {
                        $state.go('security-check');
                    }
                }
            }

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated &&
                    $rootScope.toState.parent === 'account' &&
                    ($rootScope.toState.name === 'login' ||
                        $rootScope.toState.name === 'register' ||
                        $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        stowStateAndSendSignin();
                    }
                }
            }

            function stowStateAndSendSignin(){
                // user is not authenticated. stow the state they wanted before you
                // send them to the login service, so you can return them when you're done
                storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                // now, send them to the signin state so they can log in
                $state.go('login');
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function () {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            return $sessionStorage.previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            $sessionStorage.previousState = {"name": previousStateName, "params": previousStateParams};
        }

        function loadResourceAccess(resource, corporation) {

            return $http({
                method: 'GET',
                url: '/api/authorization/' + resource + '/resource/' + corporation.id
            });
        }

        function loadActionAccess(action) {
            var corporation = CoreService.getCorporation();

            return $http({
                method: 'GET',
                url: '/api/authorization/' + action + '/action/' + corporation.id
            });
        }

        function loadActionsAccess(actions) {
            var corporation = CoreService.getCorporation();

            return AuthItem.loadActions({
                    stringList: actions,
                    id: corporation.id
            });
        }

        function resourceAuthorize(action, access) {
            if (access && access.actions && access.actions[action] && access.actions[action].roles) {
                access.actions[action].roles.push(ROLES.ROLE_SYSTEM_ADMIN);

                return access.actions[action].roles.join();
            } else {
                return [ROLES.ROLE_SYSTEM_ADMIN].join();
            }
        }

        function actionAuthorize(action, access) {
            if (access && access.action && access.roles && access.action === action) {
                access.roles.push(ROLES.ROLE_SYSTEM_ADMIN);

                return access.roles.join();
            } else {
                return [ROLES.ROLE_SYSTEM_ADMIN].join();
            }
        }

        function checkActionAuthorization(action, access) {
            if (!Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM_ADMIN])) {
                if (!access[action] || !Principal.hasAnyAuthority(access[action].roles)) {
                    $state.go('accessdenied');

                    return false;
                }
            }

            return true;
        }

        function hasActionAuthorization(action, access) {
            if (!Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM_ADMIN])) {
                if (!access[action] || !Principal.hasAnyAuthority(access[action].roles)) {

                    return false;
                }
            }

            return true;
        }
    }
})();
